<template>
    <div class="warpper-div edit-card-wrapper">
        <div v-if="[0, 2].includes(pageType)">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
                <div class="title"> {{ $t('operation.taskManage') }} </div>
                <el-form-item :label="$t('operation.task.taskName') + '：'" prop="taskName">
                    <el-input v-model="ruleForm.taskName" maxlength="32"></el-input>
                </el-form-item>
                <el-form-item :label="$t('operation.task.patrolServer') + '：'" prop="userId">
                    <el-select v-model="ruleForm.userId" filterable size="medium">
                        <el-option v-for="item in patrolServerList" :key="item.userId" :value="item.userId"
                            :label="item.userName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('operation.task.workingTime') + '：'" prop="timePeriods">
                    <div v-for="(item, index) in timePeriods" :key="index">
                        <el-time-picker style="margin-bottom: 20px;" is-range :clearable="false"
                            v-model="timePeriods[index]" format="HH:mm:ss" value-format="HH:mm:ss" range-separator="-"
                            :start-placeholder="$t('common.startdate')" :end-placeholder="$t('common.enddate')"
                            @change="changeTimePeriods($event, index)"></el-time-picker>
                        <i class="el-icon-delete" style="margin-left: 30px;cursor:pointer;" v-if="index != 0"
                            @click="clickDeleteWorkTime(index)"></i>
                    </div>
                    <!-- <div @click="clickAddWorkTime" v-if="!disabledAddTimeBtn" class="sys-task-add"> +</div> -->
                    <div :class="disabledAddTimeBtn ? 'sys-task-add disabled' : 'sys-task-add'"
                        @click="clickAddWorkTime"> +
                    </div>
                </el-form-item>
                <el-form-item :label="$t('operation.task.interval') + '：'" prop="interval">
                    <el-input-number v-model="ruleForm.interval" :min="3" :precision="0"></el-input-number>
                    <span style="margin-left: 10px;color: #5B647D;">{{ $t('operation.task.seconds') }}</span>
                </el-form-item>

                <div class="title sys-split-line"> {{ $t('operation.task.channels') }}</div>
                <ChannelTree ref="channelTreeRef" :setDisabledAttr="this.ruleForm.taskId ? true : false"></ChannelTree>
            </el-form>
            <MyFormBtn @handleSave="handleSave"></MyFormBtn>
        </div>
        <TaskDetail :dataForm="ruleForm" @updateType="updateType" :timePeriods="timePeriods" v-else></TaskDetail>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import TaskDetail from './components/taskDetail.vue'
import ChannelTree from './components/channelTree.vue'
import MyFormBtn from '@/components/myFormBtn.vue'
export default {
    data() {
        return {
            monitorId: Number(Cookies.get("monitorId")),
            pageType: 0,
            ruleForm: {
                taskName: null,
                userId: null,
                interval: 15,
            },
            rules: {
                taskName: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
                userId: [{ required: true, message: vm.$t('common.commontip') }],
                interval: [{ required: true, message: vm.$t('common.commontip')}],
            },
            patrolServerList: [],
            currentTimePeriods: ["", ""],
            timePeriods: [['00:00:00', '23:59:59']],
            timeCrossFlag: false,
            disabledAddTimeBtn: true,
        }
    },
    components: {
        TaskDetail,
        MyFormBtn,
        ChannelTree
    },
    async mounted() {
        let name = this.$route.name;
        let { id } = this.$route.params;
        await this.getServerDataList();
        if (name === 'taskAdd') {
            this.pageType = 0;
            this.$nextTick(() => {
                this.$refs.channelTreeRef.initDataList(0, `${this.$Api.captureTaskDeviceTree}/${this.monitorId}/0/0`, {});
            })
        } else if (['taskEdit', 'taskDetail'].includes(name)) {
            this.pageType = name === 'taskDetail' ? 1 : 2;
            this.ruleForm.taskId = id;
            this.getTaskDetail();
            if (this.pageType === 2) {
                this.$nextTick(() => {
                    this.$refs.channelTreeRef.initDataList(2, `${this.$Api.captureTaskDeviceTree}/${this.monitorId}/${id}/0`, this.ruleForm.cameraConfigList);
                })
            }
        }
    },
    methods: {
        clickAddWorkTime() {
            if (this.disabledAddTimeBtn) {
                return
            }
            this.timePeriods.push("");
        },
        clickDeleteWorkTime(index) {
            this.timePeriods.splice(index, 1);
            this.timeCrossFlag = false;
            this._isDisabledAddTimeBtn(this.timePeriods)
        },
        changeTimePeriods(val, index) {
            this.currentTimePeriods = val;
            if (
                this.currentTimePeriods[0].length == 0 ||
                this.currentTimePeriods[0] == this.currentTimePeriods[1]
            ) {
                return;
            }
            for (var i = 0; i < this.timePeriods.length; i++) {
                if (this.timePeriods[i] != '') {
                    const start1 = this.$moment(this.currentTimePeriods[0], 'HH:mm:ss');
                    const end1 = this.$moment(this.currentTimePeriods[1], 'HH:mm:ss');
                    const start2 = this.$moment(this.timePeriods[i][0], 'HH:mm:ss');
                    const end2 = this.$moment(this.timePeriods[i][1], 'HH:mm:ss');
                    if (
                        this.isTimeOverlap(start1, end1, start2, end2) && i !== index
                    ) {
                        this.$set(this.timePeriods, index, '')
                        this.$message.error(this.$t('operation.task.workOverlap'));
                        this.timeCrossFlag = true;
                        return;
                    }
                }
            }
            this.timeCrossFlag = false;
            this._isDisabledAddTimeBtn(this.timePeriods)
        },
        isTimeOverlap(start1, end1, start2, end2) {
            if (start1.isAfter(end2) || start2.isAfter(end1)) {
                return false;
            }
            return true;
        },
        _isDisabledAddTimeBtn(timePeriods) {
            if (timePeriods.length === 0) {
                this.disabledAddTimeBtn = false;
                return
            }
            let len = timePeriods.length;
            if (timePeriods[0][0] !== '00:00:00') {
                this.disabledAddTimeBtn = false;
                return
            }
            if (timePeriods[len - 1][1] !== '23:59:59') {
                this.disabledAddTimeBtn = false;
                return
            }

            if (len === 1) {
                if (this.timePeriods[0] === '00:00:00' && this.timePeriods[1] === '23:59:59') {
                    this.disabledAddTimeBtn = true;
                    return
                }
            }
            let flag = true;
            for (let i = 0; i < len - 1; i++) {
                var time1 = timePeriods[i][1].split(':')
                var time2 = timePeriods[i + 1][0].split(':')
                let time1_stamp = time1[0] * 3600 + time1[1] * 60 + time1[2] * 1;
                let time2_stamp = time2[0] * 3600 + time2[1] * 60 + time2[2] * 1;
                if ((time1_stamp + 1) !== time2_stamp) {
                    flag = false;
                    this.disabledAddTimeBtn = false;
                    break
                }
            }
            if (flag) {
                this.disabledAddTimeBtn = true
            }
        },
        async getServerDataList() {
            let res = await this.$Http.get(`${this.$Api.accountRoleList}/${this.monitorId}/2`)
            if (res.success) {
                this.patrolServerList = res.result;
            }
        },

        getTaskDetail() {
            let row = sessionStorage.getItem('row');
            let dataRow = JSON.parse(row || '{}');
            let captureTime = JSON.parse(dataRow.captureTime)
            let list = [];
            this.timePeriods = captureTime.timePeriods.map(
                (item, index) => {
                    list.push(item.beginTime + '-' + item.endTime);
                    return [item.beginTime, item.endTime];
                }
            );
            this.ruleForm = {
                timePeriods: list.join(','),
                taskId: dataRow.taskId,
                taskName: dataRow.taskName,
                userId: dataRow.userId,
                cameraNos: dataRow.cameraNos,
                interval: captureTime.interval,
                userName: dataRow.userName,
                enable: dataRow.enable,
                cameraConfigList: dataRow.cameraConfigList || {},
            }
            this._isDisabledAddTimeBtn(this.timePeriods);
        },
        updateType() {
            this.pageType = 2;
            this.$nextTick(() => {
                this.$refs.channelTreeRef.initDataList(2, `${this.$Api.captureTaskDeviceTree}/${this.monitorId}/${this.ruleForm.taskId}/0`, this.ruleForm.cameraConfigList);
            })
        },
        goBackClick() {
            this.$router.go(-1);
        },
        handleSave() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false;
                } else {
                    let captureTime = {
                        interval: this.ruleForm.interval,
                        timeType: 'daily'
                    };
                    let timeRangeArr = JSON.parse(JSON.stringify(this.timePeriods));
                    let flag = false;
                    captureTime.timePeriods = timeRangeArr.map((item, index) => {
                        if (item == '' || item == null || item.length === 0) {
                            flag = true;
                        }
                        return { beginTime: item[0], endTime: item[1] };
                    });
                    if (flag) {
                        this.$message.error(this.$t('operation.task.scheduleEmpty'));
                        return false;
                    }

                    let params = {
                        userId: this.ruleForm.userId,
                        taskName: this.ruleForm.taskName,
                        captureTime: JSON.stringify(captureTime)
                    };
                    let list = this.$refs.channelTreeRef.getCheckedData();
                    let checkedKeys = [];
                    let channelConfigData = this.$refs.channelTreeRef.cameraConfigList;
                    let cameraConfigList = {}
                    for (let e of list) {
                        if (e.indexOf("c") != -1) {
                            let channelId = e.split("_")[1];
                            checkedKeys.push(channelId);
                            if (channelConfigData[channelId]) {
                                cameraConfigList[Number(channelId)] = channelConfigData[channelId];
                            }
                        }
                    }
                    if (checkedKeys.length === 0) {
                        this.$message.error(this.$t('operation.task.chooseChannel'));
                        return false;
                    }
                    params.cameraNos = checkedKeys;

                    params.cameraConfigList = cameraConfigList;

                    if (this.ruleForm.taskId) {
                        params.taskId = this.ruleForm.taskId;
                        params.enable = this.ruleForm.enable;
                    } else {
                        params.enable = 1;
                    }
                    this.$Http.post(this.$Api.captureTask + '/' + this.monitorId, params).then(res => {
                        if (res.success) {
                            this.$message.success(vm.$t('common.successful'));
                            this.goBackClick();
                        }
                    });
                }
            });
        },
    },

}
</script>

<style scoped lang="scss">
.warpper-div {
    position: relative;
}

.warpper-div .el-input,
.warpper-div .el-input__inner {
    width: 232px;
}
</style>

<style lang="scss">
.warpper-div {
    .el-form-item {
        margin-bottom: 20px !important;
    }
}
</style>